import React from "react";
import HOC from "../../../components/HOC";
import AddAllocation from "../../../components/screen/centralWarehouse/allocation/AddAllocation";
import PageTemplate from "../../../components/common/particles.jsx/PageTemplate";
import { ThemeProvider } from "@mui/material";
import { theme } from "../../../components/constants/muiTheme";

const AddLocationPage = () => {
  return (
    <div className="">
      <PageTemplate
        header="New Allocation"
        mainComponent={
          <ThemeProvider theme={theme}>
            <AddAllocation />
          </ThemeProvider>
        }
        pageRole={34}
      />
    </div>
  );
};

export default HOC(AddLocationPage);
